import { render } from "./ChristmasGift.vue?vue&type=template&id=4cfff0bf&scoped=true"
import script from "./ChristmasGift.vue?vue&type=script&lang=js"
export * from "./ChristmasGift.vue?vue&type=script&lang=js"

import "./ChristmasGift.vue?vue&type=style&index=0&id=4cfff0bf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfff0bf"]])

export default __exports__